import * as _ from 'lodash';
import dynamic from 'next/dynamic';
import { ReactNode } from 'react';

import {
  ErrorNotFoundPlaceholder,
  ErrorUnauthorizedPlaceholder,
  ErrorUnexpectedPlaceholder
} from 'components/placeholders';

const Loader = dynamic(() => import('components/basic/Loader'), { ssr: false });

interface Error {
  status: number;
  message: string;
}

export default function ResponseWrapper({
  isLoading,
  error,
  children,
  loader
}: {
  isLoading: boolean;
  error: string | { status: number; message: string } | null;
  children: ReactNode;
  loader?: any;
}) {
  const loaderEl = loader || <Loader />;

  const getErrorPlaceholderEl = (error: string | { status: number; message: string }) => {
    if (_.isObject(error)) {
      const e = error as Error;

      if (e.status === 401 || (error as Error).status === 403) {
        return <ErrorUnauthorizedPlaceholder />;
      }

      if (_.isObject(error) && (error as Error).status === 404) {
        return <ErrorNotFoundPlaceholder />;
      }
    }

    return <ErrorUnexpectedPlaceholder />;
  };

  return (
    <>
      {isLoading && loaderEl}
      {!isLoading && !error && children}
      {!isLoading && error && getErrorPlaceholderEl(error)}
    </>
  );
}
